import Link from "next/link";
import React from "react";

import Image from "next/image";

import classNames from "classnames";

import ExtensionCodeExample from "assets/home/your-playground/extension-code-example.png";
import ExtensionActionPanelExample from "assets/home/your-playground/extension-action-panel-example.png";

import Hammer from "assets/iconsv2/hammer-16.svg";
import CodeBlock from "assets/iconsv2/code-block-16.svg";
import Book from "assets/iconsv2/book-16.svg";

import Container from "components/Container";

import BlockCallToAction from "./BlockCallToAction";
import Subtitle from "./Subtitle";
import styles from "./YourPlayground.module.css";
import OpenSourceTimeline from "./OpenSourceTimeline";

const YourPlayground: React.FC = () => {
  return (
    <>
      <Subtitle>
        <h3>
          Your Raycast.
          <br />
          Your playground.
        </h3>
        <p>
          Productivity is unique to everyone. Personalization is key. Extend Raycast the way you want to, and build
          tools for you and your team with the API.
        </p>
      </Subtitle>
      <Container size="lg">
        <div className={styles.buildWhatYouWant}>
          <div className={styles.codeExample}>
            <div className={styles.imgContainer}>
              <Image
                src={ExtensionCodeExample}
                width={782}
                height={556}
                layout="fixed"
                alt="Code editor with example code that show what it's like to create an ActionPanel"
              />
              <div className={styles.actionPanelImage}>
                <Image
                  src={ExtensionActionPanelExample}
                  width={416}
                  height={370}
                  alt="The Resulting ActionPanel based on the code example"
                  layout="fixed"
                />
              </div>
            </div>
          </div>
          <div className={styles.text}>
            <div className={classNames(styles.icon, styles.iconLight)}>
              <Hammer />
            </div>
            <h4>Build what you&rsquo;ve always wanted</h4>

            <p>
              Start building your perfect tools with the Raycast API, and streamline your workflows. Simply create
              Extensions with ease and publish directly to the Raycast Store seamlessly.
            </p>
            <p>Get started with the integrated developer tools in Raycast and build your first extension in no time.</p>

            <Link href="/developers">
              <a className={styles.button}>Learn more</a>
            </Link>
          </div>
        </div>

        <div className={styles.collection}>
          <div className={styles.openSource}>
            <div className={styles.text}>
              <div className={classNames(styles.icon, styles.iconDark)}>
                <CodeBlock />
              </div>
              <h4>Open source community</h4>

              <p>
                Build in the open and collaborate with other Developers on yours and their Extensions. Contribute as
                you&rsquo;d like, and help others by building on top of existing Extensions.
              </p>
            </div>

            <div className={styles.image}>
              <OpenSourceTimeline />
            </div>
          </div>

          <div className={styles.partOfTheStory}>
            <div className={classNames(styles.icon, styles.iconDark)}>
              <Book />
            </div>

            <div className={styles.text}>
              <h4>Be part of the story</h4>

              <p>
                We listen to our community and build Raycast in collaboration with developers, to build the best product
                and developer experience across the platform.
              </p>
            </div>
          </div>
        </div>

        <BlockCallToAction href="https://developers.raycast.com" target="_blank" rel="noreferrer">
          Explore the docs
        </BlockCallToAction>
      </Container>
    </>
  );
};

export default YourPlayground;
